import { render, staticRenderFns } from "./TicketAction.vue?vue&type=template&id=3f5473f8"
import script from "./TicketAction.vue?vue&type=script&lang=js"
export * from "./TicketAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports